import React from "react"
import {SelfieUpload} from "../../../selfie_upload/selfie_upload";
import {domToReact} from "html-react-parser";


const Description = () => {
  const descriptions =  [
    {
      dataAttributeName: "data-target-width",
      required: true,
      description: "The width of the image that will be uploaded."
    },
    {
      dataAttributeName: "data-target-height",
      required: true,
      description: "The height of the image that will be uploaded."
    },
    {
      dataAttributeName: "data-selection-mode",
      description: "Can be 'file', 'camera', or 'all' (default) - determines what the user can select."
    },
    {
      dataAttributeName: "data-mode",
      description: "Can be 'video' or 'image' (default) "
    },
    {
      dataAttributeName: "data-max-video-length-seconds",
      description: "The maximum length of the video in seconds. Only applies if data-mode is 'video' and data-selection-mode is 'camera' or 'all'"
    },
    {
      dataAttributeName: "data-upload-file-identifier",
      description: "Identifier that will be set for the uploaded image."
    },
    {
      dataAttributeName: "data-pintura-config",
      description: "Pintura config, if set, this will overwrite the target-width and target-height."
    },
    {
      dataAttributeName: "data-facing-mode",
      description: "Can be 'user' or 'environment' (default) - determines which camera to use."
    },
    {
      dataAttributeName: "data-picture-mode",
      description: "Can be 'media_files', 'tag_owner_images', or 'stored_photos' (default) - Determines as what the images will be uploaded."
    },
    {
      dataAttributeName: "data-media-select-button-orientation",
      description: "Orientation of the media select button. Can be 'vertical' or 'horizontal' (default) - determines the orientation of the media select button."
    },
    {
      dataAttributeName: "data-show-upload-confirmation",
      description: "If set to 'true', the user will be asked to confirm the upload. Default is 'false'."
    },
  ]

  return <div>
    <h2>
      Selfie Upload
    </h2>
    <p>Below you find a list with all the selfie upload attributes that can be set.</p>
    <ul>
      {descriptions.map(description => {
        return <li key={description.dataAttributeName}>
          <strong>{description.dataAttributeName}{description.required ? " (required)" : ""}</strong>:
          {" "}
          {description.description}
        </li>
      })}
    </ul>
  </div>
}


export const RenderedSelfieUpload = ({node, options}) => {
  const thankYou = domToReact(node.children, options)

  const selectionMode = node.attribs["data-selection-mode"] || "all"
  const mode = node.attribs["data-mode"] || "image"
  const maxVideoLengthSeconds = parseInt(node.attribs["data-max-video-length-seconds"])
  const uploadFileIdentifier = node.attribs["data-upload-file-identifier"]
  const pinturaConfig = node.attribs["data-pintura-config"]
  const targetWidth = parseInt(node.attribs["data-target-width"])
  const targetHeight = parseInt(node.attribs["data-target-height"])
  const facingMode = node.attribs["data-facing-mode"] || 'user'
  const pictureMode = node.attribs["data-picture-mode"] || 'stored_photos'
  const mediaSelectButtonOrientation = node.attribs["data-media-select-button-orientation"] || 'horizontal'
  const showUploadConfirmation = node.attribs["data-show-upload-confirmation"] === "true"

  if (!node.attribs["data-target-width"] || !node.attribs["data-target-height"]) {
    return <div>
      <Description />
    </div>
  }

  if (!['file','camera','all'].includes(selectionMode)) {
    alert("data-selection-mode must be one of 'file', 'camera', or 'all'")
  }

  if (!['video', 'image'].includes(mode)) {
    alert("data-mode must be one of 'video' or 'image'")
  }

  if (selectionMode === "video") {
    if (!maxVideoLengthSeconds || isNaN(maxVideoLengthSeconds) || maxVideoLengthSeconds <= 0) {
      alert("data-max-video-length-seconds must be a positive number")
    }
  }

  if (!targetWidth || isNaN(targetWidth) || targetWidth <= 0) {
    alert("data-target-width must be a positive number")
  }

  if (!targetHeight || isNaN(targetHeight) || targetHeight <= 0) {
    alert("data-target-height must be a positive number")
  }

  if (!['user', 'environment'].includes(facingMode)) {
    alert("data-facing-mode must be one of 'user' or 'environment'")
  }

  if (!['media_files', 'tag_owner_images', 'stored_photos'].includes(pictureMode)) {
    alert("data-picture-mode must be one of 'media_files', 'tag_owner_images', or 'stored_photos'")
  }

  if (!['vertical', 'horizontal'].includes(mediaSelectButtonOrientation)) {
    alert("data-media-select-button-orientation must be one of 'vertical', 'horizontal'")
  }

  return <SelfieUpload
    selectionMode={selectionMode}
    mode={mode}
    maxVideoLengthSeconds={maxVideoLengthSeconds}
    uploadFileIdentifier={uploadFileIdentifier}
    pinturaConfig={pinturaConfig}
    thankYou={thankYou}
    targetWidth={targetWidth}
    targetHeight={targetHeight}
    facingMode={facingMode}
    pictureMode={pictureMode}
    mediaSelectButtonOrientation={mediaSelectButtonOrientation}
    showUploadConfirmation={showUploadConfirmation}
  />
}